import api from './api';

export type ChannelStatus = 'not_set' | 'connected' | 'failing' | 'not_active';

export interface TelegramChannel {
  id: string;
  kind: 'telegram';
  status: ChannelStatus;
  status_display: string;
  is_enabled: boolean;
  bot_username: string;
  bot_link: string;
  /** Masked (1234****xyz). The token itself never comes back from the server. */
  token_hint: string;
  connected_at: string | null;
  last_error: string;
  last_error_at: string | null;
  last_delivery_at: string | null;
}

export interface WhatsAppChannel {
  id: string;
  kind: 'whatsapp';
  status: ChannelStatus;
  status_display: string;
  wa_provider: '' | 'meta_cloud' | 'gupshup';
  wa_display_number: string;
  wa_phone_number_id: string;
  wa_business_account_id: string;
  wa_access_token_hint: string;
  wa_verify_token_set: boolean;
}

export interface MessagingChannels {
  telegram: TelegramChannel;
  whatsapp: WhatsAppChannel;
}

export interface WhatsAppPlaceholderInput {
  wa_provider: 'meta_cloud' | 'gupshup';
  wa_display_number: string;
  wa_phone_number_id: string;
  wa_business_account_id: string;
  /** Blank keeps what is stored. */
  wa_access_token: string;
  wa_verify_token: string;
}

export interface TelegramTestResult {
  ok: boolean;
  bot_username: string;
  webhook_ok: boolean;
  pending_update_count: number;
  last_error_message: string;
}

export interface ChannelOverviewRow {
  broker_id: string;
  broker_name: string;
  broker_code: string;
  telegram_status: ChannelStatus;
  telegram_bot_username: string;
  telegram_last_error_at: string | null;
  telegram_last_delivery_at: string | null;
  whatsapp_status: ChannelStatus;
  whatsapp_provider: string;
  whatsapp_configured: boolean;
}

const BASE = '/messaging/channels';

export const messagingService = {
  getChannels: async (): Promise<MessagingChannels> => (await api.get<MessagingChannels>(`${BASE}/`)).data,
  connectTelegram: async (botToken: string): Promise<TelegramChannel> =>
    (await api.post<TelegramChannel>(`${BASE}/telegram/connect/`, { bot_token: botToken })).data,
  testTelegram: async (): Promise<TelegramTestResult> =>
    (await api.post<TelegramTestResult>(`${BASE}/telegram/test/`)).data,
  rotateTelegram: async (): Promise<TelegramChannel> =>
    (await api.post<TelegramChannel>(`${BASE}/telegram/rotate/`)).data,
  disconnectTelegram: async (): Promise<TelegramChannel> =>
    (await api.post<TelegramChannel>(`${BASE}/telegram/disconnect/`)).data,
  saveWhatsApp: async (input: WhatsAppPlaceholderInput): Promise<WhatsAppChannel> =>
    (await api.put<WhatsAppChannel>(`${BASE}/whatsapp/`, input)).data,
  getOverview: async (): Promise<ChannelOverviewRow[]> =>
    (await api.get<ChannelOverviewRow[]>(`${BASE}/overview/`)).data,
};
